module.exports = __webpack_public_path__ + "static/why-content-image-4-eb42bbd1d2050bbb15a77d4250eb3045.svg";